import { MsalProvider } from '@azure/msal-react'
import { DateFnsLocaleProvider } from '@if/core/date'
import i18n, { initializeI18N } from '@if/core/i18n'
import { initializeTelemetry } from '@if/core/telemetry'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import LocaleProvider from './components/LocaleProvider'
import App from './containers/App/App'
import './index.css'
import msalInstance, { initializeMsal } from './services/Authentification'
import { reportErrorToConsole } from './services/error-logger'

initializeTelemetry({
  instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTAL_KEY,
  appName: 'manage-merchant',
})

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } })
const container = document.getElementById('root')
const root = createRoot(container!)

Promise.all([initializeI18N(), initializeMsal()])
  .then(() => {
    root.render(
      <Suspense fallback="loading">
        <I18nextProvider i18n={i18n}>
          <MsalProvider instance={msalInstance}>
            <QueryClientProvider client={queryClient}>
              <DateFnsLocaleProvider>
                <LocaleProvider>
                  <App />
                  <ReactQueryDevtools initialIsOpen={false} />
                </LocaleProvider>
              </DateFnsLocaleProvider>
            </QueryClientProvider>
          </MsalProvider>
        </I18nextProvider>
      </Suspense>,
    )
  })
  .catch(reportErrorToConsole)
